import React, { useEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

import InputForForm from "../../../GeneralComponents/componentsForForm/inputForForm/InputForForm";
import SelectWithSearch from "../../../GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";

import { setAddressOptions, setMidnameRequiredByDocType, toggleHandWritingMode } from "../optionsBoatInfo";

import {
  addNewBoatInfo,
  editBoatInfo,
  updateBoatInfo,
  updateBoatInfoForId,
  updateBoatInfoForIdDeals,
} from "../../../../redux/smallBoatsReducer/actionsSmallBoats";

import styles from "./boatInfoModalWindow.module.css";

function BoatInfoModalWindow({ show, setShow, options, clearOptionsModalWindow }) {
  const {
    register,
    unregister,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
  } = useForm();

  const dispatch = useDispatch();

  const [localOptions, setLocalOptions] = useState({ ...options });
  console.log(localOptions);
  const [file, setFile] = useState("");
  const userInfo = useSelector((state) => state.dictionaryReducer.userInfo);

  const handWritingWatch = useWatch({
    control,
    name: "handWriting",
  });

  const oblIdWatch = useWatch({ control, name: "oblId" });
  const rayonIdWatch = useWatch({ control, name: "rayonId" });
  const gorodIdWatch = useWatch({ control, name: "gorodId" });
  const docTypeWatch = useWatch({ control, name: "docType" });

  const prevValuesRef = useRef({
    oblId: oblIdWatch,
    rayonId: rayonIdWatch,
    gorodId: gorodIdWatch,
  });

  const closeWindow = (e) => {
    e?.preventDefault();
    clearOptionsModalWindow();
    setShow(!show);
  };

  const handleFile = (e) => {
    if (e.target.files) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const resolveSubmit = (data) => {
    if (options.mode === "add") {
      dispatch(
        addNewBoatInfo({
          key: options.key,
          data: options.key === "documents" ? file : data,
        }),
      );
    } else if (options.mode === "edit" && !options.isHistory) {
      const updateStrategies = {
        boatArrestsDtos: () => ({ ...options.data, ...data, isActiv: false }),
        boatCardSpecmarksDtoList: () => ({
          ...data,
          bsmLock: data.bsmLock === "on",
          id: options.data.id,
        }),
        default: () => ({ ...data, id: options.data.id }),
      };

      dispatch(
        editBoatInfo({
          key: options.key,
          data: (updateStrategies[options.key] || updateStrategies.default)(),
        }),
      );
    } else if (options.isHistory && (options.key === "enginesList" || options.key === "staticEngineList")) {
      dispatch(
        updateBoatInfoForId({
          key: options.key,
          data: {
            ...data,
            engstatid: options.data.engstatid,
            engineTypeIdName:
              data.engineTypeIdName ||
              localOptions.inputs.engineTypeId.options.find((option) => option.value === data.engineTypeId)
                ?.label,
          },
        }),
      );
    } else if (options.isHistory && options.key === "boatDeals") {
      dispatch(
        updateBoatInfoForIdDeals({
          key: options.key,
          data: {
            ...data,
            dealId: options.data.dealId,
          },
        }),
      );
    } else if (options.isHistory) {
      Object.values(options.inputs).forEach((item) => {
        if (item.type === "selectWithSearch" && data[item.key]) {
          data[`${item.key}Name`] = item.options.find((option) => option.value === data[item.key])?.label;
        }
      });
      if (options.key === "ownerInformation") {
        data = {
          ...data,
          fio: data.surname ? `${data.surname} ${data.name} ${data.midname || ""}` : null,
          leName: data.nameLe
            ? `${data.nameLe}, УНП ${data.unp}, зарегистрирован - ${data.docDepartmentLe}, ЕГР ${data.egrNum} `
            : null,
          ownerDocType: data.surname
            ? `${data.docTypeName}, ${data.serialOfPassport}${data.numberOfPassport}, выдан ${data.docDepartment}, идентификационный номер ${data.persNum}`
            : null,
          ownerAddress: [
            data.oblIdName ? (data.oblIdName === "Минск" ? "г. Минск" : `${data.oblIdName} обл.`) : null,
            data.rayonIdName ? `${data.rayonIdName} р-н` : null,
            data.gorodIdName ? data.gorodIdName : null,
            data.ulica ? `улица: ${data.ulica}` : null,
            data.dom ? `дом: ${data.dom}` : null,
            data.korpus ? `корпус: ${data.korpus}` : null,
            data.kv ? `кв: ${data.kv}` : null,
          ]
            .filter(Boolean)
            .join(", "),
        };
      }

      dispatch(updateBoatInfo({ key: options.key, data: data }));
    }
    clearOptionsModalWindow();
    setShow(!show);
  };

  useEffect(() => {
    if (options.keyModal === "boatArrestsDtos") {
      if (userInfo.note === "concerned") {
        setValue(
          `${options.inputs.hasOwnProperty("onOfficer") ? "onOfficer" : "onOfficer"}`,
          userInfo.userid,
        );
        setValue(
          `${options.inputs.hasOwnProperty("onOrg") ? "onOrg" : "offOrg"}`,
          userInfo.departament?.depName,
        );
      }
    }
  }, []);

  useEffect(() => {
    if (options.keyModal === "boatArrestsDtos") {
      if (handWritingWatch === undefined) {
        setValue("handWriting", false);
        setLocalOptions({ ...localOptions, ...toggleHandWritingMode(false, options) });
        return;
      }
      setLocalOptions({ ...localOptions, ...toggleHandWritingMode(handWritingWatch, options) });
      if (localOptions.inputs.hasOwnProperty("onOfficer")) {
        unregister("onOfficer");
        register("onOfficer");
      } else {
        unregister("offOfficer");
        register("offOfficer");
      }
    }
  }, [handWritingWatch]);

  useEffect(() => {
    const prevValues = prevValuesRef.current;

    let changedField;

    if (oblIdWatch !== prevValues.oblId) {
      changedField = "oblId";
    } else if (rayonIdWatch !== prevValues.rayonId) {
      changedField = "rayonId";
    } else if (gorodIdWatch !== prevValues.gorodId) {
      changedField = "gorodId";
    }

    if (changedField) {
      const update = async () => {
        const options = await setAddressOptions(getValues(), changedField, localOptions.data.ownerTypeId);
        setLocalOptions({ ...localOptions, ...options });

        if (changedField === "oblId") {
          setValue("rayonId", undefined);
          setValue("gorodId", undefined);
        }
      };

      update();
    }

    prevValuesRef.current = {
      oblId: oblIdWatch,
      rayonId: rayonIdWatch,
      gorodId: gorodIdWatch,
    };
  }, [oblIdWatch, rayonIdWatch, gorodIdWatch]);

  useEffect(() => {
    if (docTypeWatch !== undefined) {
      setLocalOptions({
        ...localOptions,
        ...setMidnameRequiredByDocType(docTypeWatch),
      });
      clearErrors("midname");
    }
  }, [docTypeWatch]);

  return (
    <Modal
      show={show}
      onHide={closeWindow}>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{options.caption}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <form
          className={styles["form-inputs-container"]}
          onSubmit={handleSubmit(resolveSubmit)}>
          {Object.values(localOptions.inputs).map((option) => {
            if (option.hidden) return null;

            const inputComponent =
              option.type === "selectWithSearch" ? (
                <SelectWithSearch
                  key={option.key}
                  mode={options.mode}
                  register={register}
                  inputProps={option}
                  errors={errors}
                  setValue={setValue}
                  control={control}
                  dataForm={options.data}
                />
              ) : option.type === "file" ? (
                <label
                  className={styles["input-file"]}
                  key={option.key}>
                  <span className={styles["input-file-btn"]}>Выберите файлы</span>
                  <input
                    type="file"
                    name="file"
                    accept="*"
                    onChange={handleFile}
                  />
                  <span className={styles["input-file-text"]}>
                    <span className={styles["file-name"]}>{file ? file.name : "Не выбрано"}</span>
                    <div className={styles["icons-block"]}>
                      {file && (
                        <span
                          onClick={clearFile}
                          className={styles["delete-icon"]}></span>
                      )}
                      <span className={styles["paperclip"]}></span>
                    </div>
                  </span>
                </label>
              ) : option.caption ? (
                <p
                  key={option.key}
                  className={styles["secondary-caption"]}>
                  {option.caption}
                </p>
              ) : (
                <InputForForm
                  key={option.key}
                  mode={options.mode}
                  register={register}
                  unregister={unregister}
                  inputProps={option}
                  errors={errors}
                  setValue={setValue}
                  dataForm={options.data}
                  getValues={getValues}
                />
              );

            return inputComponent;
          })}
          <Modal.Footer className={styles["form-footer"]}>
            <button className={styles["save-btn"]}>Сохранить</button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default BoatInfoModalWindow;
